import { z } from 'zod';

// Schemas for decision type for org operations and account transactions
export const orgOperationDecisionSchema = z.enum(['APPROVE', 'REJECT']);
export const accountTransactionDecisionSchema = z.enum([
  ...orgOperationDecisionSchema.options,
  'INITIATE',
]);

// Enums for decision of org operation and account transactions
export const OrgOperationDecision = orgOperationDecisionSchema.enum;
export const AccountTransactionDecision = accountTransactionDecisionSchema.enum;

// Typescript types for decision of org operation and account transaction
export type OrgOpSignableDecision = z.infer<typeof orgOperationDecisionSchema>;
export type AcctTxSignableDecision = z.infer<
  typeof accountTransactionDecisionSchema
>;
export type AnySignableDecision =
  | OrgOpSignableDecision
  | AcctTxSignableDecision;
